export default __webpack_public_path__ + "assets/2e260f4fdf9efa8564cc65687835c9b2.svg";